import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  const statusStats = [
    { label: 'Açık', value: stats?.byStatus?.open || 0, icon: 'AlertCircle', color: 'text-blue-600 bg-blue-100' },
    { label: 'İşlemde', value: stats?.byStatus?.in_progress || 0, icon: 'Clock', color: 'text-purple-600 bg-purple-100' },
    { label: 'Çözüldü', value: stats?.byStatus?.resolved || 0, icon: 'CheckCircle', color: 'text-green-600 bg-green-100' },
    { label: 'Kapalı', value: stats?.byStatus?.closed || 0, icon: 'XCircle', color: 'text-gray-600 bg-gray-100' }
  ];

  const priorityStats = [
    { label: 'Acil', value: stats?.byPriority?.urgent || 0, color: 'text-red-600 bg-red-100' },
    { label: 'Yüksek', value: stats?.byPriority?.high || 0, color: 'text-orange-600 bg-orange-100' },
    { label: 'Orta', value: stats?.byPriority?.medium || 0, color: 'text-yellow-600 bg-yellow-100' },
    { label: 'Düşük', value: stats?.byPriority?.low || 0, color: 'text-green-600 bg-green-100' }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statusStats?.map((stat, index) => (
        <div key={index} className="bg-card rounded-xl shadow-organic p-6">
          <div className="flex items-center justify-between mb-2">
            <div className={`w-12 h-12 rounded-lg ${stat?.color} flex items-center justify-center`}>
              <Icon name={stat?.icon} size={24} />
            </div>
            <span className="text-3xl font-bold text-foreground">{stat?.value}</span>
          </div>
          <p className="text-sm text-muted-foreground">{stat?.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsOverview;